<template>
  <div
    class="relative mb-1 inline-block overflow-clip whitespace-nowrap rounded-sm border border-obsidian-400 bg-white p-[0.1rem] pl-[0.6rem] pr-[0.2rem] align-top text-[0.65rem] text-obsidian-800 before:absolute before:inset-0 before:h-full before:w-[0.4rem] before:bg-blue-700"
    style="font-family: FE, sans-serif"
  >
    <slot />&ZeroWidthSpace;
  </div>
</template>
<script setup lang="ts"></script>
